import React, {useEffect, useState} from "react";
import styles from "../../../styles/main.module.css";
import Header from "../../components/header/header";
import SidebarProvider from "../../components/sidebar/sidebar";
import Title from "../../../components/title/title";
import Loading from "../../../components/loading/loading";
import TableComponent from "../../../components/table/table";
import axiosInstance from "../../../AxiosInstance";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import {PrimaryButton} from "../../../components/input/inputs";
import DeleteModal from "../../../components/delete_modal/delete_modal";
import CreateCompanyModal from "./modals/create_modal";
import EditCompanyModal from "./modals/edit_modal";

export default function CompanySettings() {
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [rows, setRows] = useState([])

    const preDelete = (id) => {
        setDeleteId(id);
        setShowDelete(true);
    }

    const cols = [
        {title: 'RUC', internal: 'ruc'},
        {title: 'Razón Social', internal: 'name'},
        {title: 'Categoría', internal: 'type'},
        {title: 'Estado', internal: 'active', code: (row, data) => {
            return (
                <div>{data === false ? 'Inactivo' : 'Activo'}</div>
            );
            }},
        {
            title: 'Acciones',
            buttons: [
                {
                    icon: faEdit,
                    color: "#44A04A",
                    onClick: (id) => {
                        setSelectedCompany(id);
                        setShowEdit(true);
                    }
                },
                {
                    icon: faTrash,
                    color: "#DC3545",
                    onClick: preDelete
                }
            ]
        }
    ]

    useEffect(() => {
        axiosInstance.get('company/').then((response) => {
            setRows(response.data);
        })
    }, [])

    const deleteObj = () => {
        axiosInstance.delete('company/' + deleteId + '/').then((response) => {
            window.location.reload();
        });
    }

    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className={styles.mainContainer}>
            <Header setSidebarOpen={setSidebarOpen}/>
            <SidebarProvider isOpen={sidebarOpen} index={4}/>

            <CreateCompanyModal show={showCreate} setter={setShowCreate}/>
            <EditCompanyModal show={showEdit} setter={setShowEdit} rows={rows} id={selectedCompany}/>

            <DeleteModal show={showDelete} setter={setShowDelete} name={'la empresa'} buttonName={'Guardar'} onClick={deleteObj}/>

            <div className={styles.container} style={!sidebarOpen ? {marginLeft: '80px'} : {marginLeft: '285px'}}>
                <Title name={'Creación de Empresas'}/>

                <div className={`${styles.secondaryContainer}`}>
                    <div className={'d-flex justify-content-end'}>
                        <PrimaryButton name={'Agregar Empresa'} onClick={() => {
                            setShowCreate(true);
                        }}/>
                    </div>
                    {
                        //Pagination HERE
                        rows.length === 0 ? <Loading/> :
                            <TableComponent
                                noPagination={true}
                                fetchUrl={'company'}
                                pull={setRows}
                                cols={cols}
                                rows={rows}
                            />
                    }
                </div>
            </div>
        </div>
    );
}